import React from 'react';
export function ScientificReframe() {
  const comparisons = [{
    belief: 'Necesito dormir más horas',
    reality: 'No es cuánto duermes, es cómo recuperas'
  }, {
    belief: 'Soy mal dormidor por naturaleza',
    reality: 'Tu patrón se puede reconfigurar'
  }, {
    belief: 'Es el estrés, no puedo hacer nada',
    reality: 'El estrés tiene un protocolo de respuesta'
  }, {
    belief: 'Necesito pastillas para dormir',
    reality: 'Tu cuerpo tiene un sistema natural'
  }, {
    belief: 'Así soy yo',
    reality: 'Es fisiología, no destino'
  }];
  return <section className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-265">
      <div className="max-w-4xl mx-auto" data-id="element-266">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-267">
          LA VERDAD
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-268">
          La verdad que nadie te explicó
          <br data-id="element-269" />
          sobre tu cansancio
        </h2>

        {/* Desktop Comparison Table - hidden on mobile */}
        <div className="hidden md:block mb-12" data-id="element-270">
          {/* Headers */}
          <div className="grid grid-cols-2 gap-1 mb-1" data-id="element-271">
            <div className="bg-alert/20 rounded-tl-xl p-4 text-center" data-id="element-272">
              <span className="text-alert font-bold text-lg" data-id="element-273">
                ❌ Lo que creías
              </span>
            </div>
            <div className="bg-cta/20 rounded-tr-xl p-4 text-center" data-id="element-274">
              <span className="text-cta font-bold text-lg" data-id="element-275">
                ✅ Lo que realmente pasa
              </span>
            </div>
          </div>

          {/* Rows */}
          {comparisons.map((item, index) => <div key={index} className="grid grid-cols-2 gap-1 mb-1" data-id="element-276">
              <div className={`bg-navy-light p-4 ${index === comparisons.length - 1 ? 'rounded-bl-xl' : ''}`} data-id="element-277">
                <p className="text-gray-300" data-id="element-278">{item.belief}</p>
              </div>
              <div className={`bg-navy-light p-4 ${index === comparisons.length - 1 ? 'rounded-br-xl' : ''}`} data-id="element-279">
                <p className="text-white font-medium" data-id="element-280">{item.reality}</p>
              </div>
            </div>)}
        </div>

        {/* Mobile Comparison Cards - visible only on mobile */}
        <div className="md:hidden space-y-4 mb-12" data-id="element-281">
          {comparisons.map((item, index) => <div key={index} className="bg-navy-light rounded-xl overflow-hidden" data-id="element-282">
              {/* Belief */}
              <div className="border-l-4 border-alert p-4 bg-alert/5" data-id="element-283">
                <span className="text-alert text-xs font-bold uppercase tracking-wider block mb-1" data-id="element-284">
                  Lo que creías
                </span>
                <p className="text-gray-300 text-base" data-id="element-285">❌ {item.belief}</p>
              </div>
              {/* Divider */}
              <div className="flex items-center justify-center py-1 bg-navy-light" data-id="element-286">
                <span className="text-gray-500 text-lg" data-id="element-287">↓</span>
              </div>
              {/* Reality */}
              <div className="border-l-4 border-cta p-4 bg-cta/5" data-id="element-288">
                <span className="text-cta text-xs font-bold uppercase tracking-wider block mb-1" data-id="element-289">
                  Lo que realmente pasa
                </span>
                <p className="text-white text-base font-medium" data-id="element-290">
                  ✅ {item.reality}
                </p>
              </div>
            </div>)}
        </div>

        {/* Callout Box */}
        <div className="border-2 border-cyan bg-navy-light rounded-xl p-5 md:p-8" data-id="element-291">
          <p className="text-cyan font-bold text-lg mb-4" data-id="element-292">🔬 DATO CLAVE</p>

          <p className="text-white mb-4 text-base md:text-lg" data-id="element-293">
            Tu sistema nervioso tiene dos modos:
          </p>

          <div className="space-y-3 mb-5" data-id="element-294">
            <div className="bg-navy/50 rounded-lg p-3 md:p-4 border-l-4 border-alert/60" data-id="element-295">
              <p className="text-white text-base" data-id="element-296">
                ⚡ <span className="font-semibold" data-id="element-297">SIMPÁTICO</span>
              </p>
              <p className="text-gray-300 text-sm mt-1" data-id="element-298">
                Alerta · Estrés · Defensa
              </p>
            </div>
            <div className="bg-navy/50 rounded-lg p-3 md:p-4 border-l-4 border-cta/60" data-id="element-299">
              <p className="text-white text-base" data-id="element-300">
                🌿 <span className="font-semibold" data-id="element-301">PARASIMPÁTICO</span>
              </p>
              <p className="text-gray-300 text-sm mt-1" data-id="element-302">
                Calma · Recuperación · Descanso real
              </p>
            </div>
          </div>

          <p className="text-gray-300 mb-4 text-base" data-id="element-303">
            Para que el sueño sea reparador, el sistema parasimpático debe
            dominar.
          </p>

          <p className="text-gray-300 mb-5 text-base" data-id="element-304">
            El estrés acumulado, las pantallas, la cafeína y la rumiación mental
            mantienen activo el sistema simpático… incluso mientras duermes.
          </p>

          <div className="bg-cyan/10 border border-cyan/30 rounded-lg p-4 mb-4" data-id="element-305">
            <p className="text-white text-base md:text-lg" data-id="element-306">
              Esto se llama:{' '}
              <span className="text-cyan font-bold block mt-1 text-lg md:text-xl" data-id="element-307">
                HIPERACTIVACIÓN AUTÓNOMA NOCTURNA
              </span>
            </p>
          </div>

          <p className="text-cta font-semibold text-base md:text-lg" data-id="element-308">
            Y es exactamente lo que vamos a corregir.
          </p>
        </div>
      </div>
    </section>;
}